'use strict';
var angular = require('angular');

module.exports = function($uibModal) {
    var options = {
        animation: true,
        controller: ['$uibModalInstance', 'data', function($uibModalInstance, data) {
            this.data = data;
        }],
        templateUrl: 'dialogs/dialogs.html',
        controllerAs: 'modal',
        size: 'sm',
        windowClass: 'dialog',
        bindToController: true
    };
    return {
        confirm: function(data) {
            var tempObject = angular.extend({}, options);

            //new size or default SM
            tempObject.size = data.size || tempObject.size;

            if (data) {
                tempObject.resolve = {
                    data: function() {
                        return {
                            title: data.title,
                            body: data.body,
                            accept: data.accept || 'Aceptar',
                            cancel: data.cancel || 'Cancelar',
                            html: data.html || false
                        };
                    }
                };
            } else {
                tempObject.resolve = {
                    data: function() {
                        return {
                            title: '',
                            body: '',
                            accept: 'Aceptar',
                            cancel: 'Cancelar'
                        };
                    }
                };
            }

            return $uibModal.open(tempObject).result;
        },
        alert: function(data) {
            var tempObject = angular.extend({}, options);
            tempObject.size = data.size || tempObject.size;
            tempObject.resolve = {
                data: function() {
                    return {
                        title: data.title,
                        body: data.body,
                        cancel: data.close || 'Cerrar',
                        html: data.html || false
                    };
                }
            };
            return $uibModal.open(tempObject).result;
        }
    };
};
